var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Attention as AttentionIcon, Information as InformationIcon, Success as SuccessIcon, Warning as WarningIcon, } from 'pcln-icons';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Text } from '../Text';
import { CloseButton } from '../CloseButton';
import { applyVariations, deprecatedColorValue } from '../utils';
var bannerColors = {
    green: {
        backgroundColor: 'secondary.base',
        color: 'text.lightest',
        icon: React.createElement(SuccessIcon, null),
    },
    lightGreen: {
        backgroundColor: 'secondary.light',
        color: 'secondary.dark',
        icon: React.createElement(SuccessIcon, null),
    },
    red: {
        backgroundColor: 'error.base',
        color: 'text.lightest',
        icon: React.createElement(WarningIcon, null),
    },
    lightRed: {
        backgroundColor: 'error.light',
        color: 'error.dark',
        icon: React.createElement(WarningIcon, null),
    },
    orange: {
        backgroundColor: 'alert.base',
        color: 'text.lightest',
        icon: React.createElement(AttentionIcon, null),
    },
    blue: {
        backgroundColor: 'primary.base',
        color: 'text.lightest',
        icon: React.createElement(InformationIcon, null),
    },
    lightBlue: {
        backgroundColor: 'primary.light',
        color: 'primary.dark',
        icon: React.createElement(InformationIcon, null),
    },
};
var StyledBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), applyVariations('Banner'));
var propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.node,
    onClose: PropTypes.func,
    showIcon: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    textAlign: PropTypes.string,
    color: deprecatedColorValue(),
    bg: deprecatedColorValue(),
    children: PropTypes.node,
};
var Banner = function (props) {
    var bannerColor = bannerColors[!props.bg && props.color === 'green' ? props.color : props.bg] || {};
    var Icon = props.icon || bannerColor.icon;
    var color = !bannerColor.color ? props.color : bannerColor.color;
    var header = null;
    if (props.header) {
        header = React.isValidElement(props.header) ? (props.header) : (React.createElement(Text, { textStyle: 'display2' }, props.header));
    }
    return (React.createElement(StyledBox, __assign({}, props, { bg: bannerColor.backgroundColor || props.bg, color: color }),
        React.createElement(Flex, { justifyContent: 'space-between', alignItems: 'flex-start' },
            !!Icon && !!props.showIcon && React.cloneElement(Icon, { mr: 2, size: 24, mt: '-2px' }),
            React.createElement(Box, { textAlign: props.textAlign, width: 1 },
                header,
                React.createElement(Text.span, { fontSize: 1 }, props.text),
                props.children),
            !!props.onClose && React.createElement(CloseButton, { onClick: props.onClose, ml: 2, size: 24, title: 'close', mt: '-2px' }))));
};
Banner.propTypes = propTypes;
Banner.displayName = 'Banner';
Banner.defaultProps = {
    textAlign: 'left',
    showIcon: true,
    color: 'green',
};
export default withTheme(Banner);
var templateObject_1;
//# sourceMappingURL=Banner.js.map